import LoaderFullPage from './LoaderFullPage';

export default LoaderFullPage;
